export default __webpack_public_path__ + "static/media/mirador de catarina.619c5db3.jpg";